import Avatar from '@base/Avatar/Avatar';
import styled from '@emotion/styled';
import OfflineIcon from '@icon/Groups/Offline';
import { Spacings } from '@styles/index';
import * as React from 'react';
import updateQuery from '@utils/updaetQuery';
import { GroupsStatus, IGroupUser } from 'types/groups/index';

interface IGroupsUserAvatarProps {
  length: number;
  user: IGroupUser;
  size?: string;
  type?: string;
}

interface IUserAvatarProps {
  desaturate?: boolean;
  size?: string;
}

const UserAvatar = styled(Avatar)<IUserAvatarProps>`
  border: ${Spacings.SPACING_1} solid var(--color-divider);
  box-sizing: border-box;
  filter: ${(props) => (props.desaturate ? 'grayscale(100%)' : 'none')};
  overflow: hidden;
  cursor: ${(props) => props.className};
  min-height: ${(props) => props.size ?? Spacings.SPACING_10B};
  min-width: ${(props) => props.size ?? Spacings.SPACING_10B};
  max-height: ${(props) => props.size ?? Spacings.SPACING_10B};
  max-width: ${(props) => props.size ?? Spacings.SPACING_10B};
`;

const OnlineIndicator = styled.div`
  background: var(--color-i-accent-green);
  border-radius: ${Spacings.SPACING_4B};
  height: 100%;
  width: 100%;
  display: block;
`;

const StatusWrapper = styled.div`
  background: var(--color-base-1);
  border: 2px solid var(--color-base-1);
  border-radius: ${Spacings.SPACING_4B};
  height: ${({
    // @ts-ignore
    size
  }) => size};
  width: ${({
    // @ts-ignore
    size
  }) => size};
  position: absolute;
  box-sizing: border-box;
  bottom: ${({
    // @ts-ignore
    position
  }) => position};
  right: ${({
    // @ts-ignore
    position
  }) => position};
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface IContainerProps {
  length: number;
}
const Container = styled.div<IContainerProps>`
  display: flex;
  position: relative;
  width: max-content;
`;

const GroupsUserAvatar: React.FC<IGroupsUserAvatarProps> = ({
  user,
  length,
  size,
  type
}) => {
  const { name, avatar, status } = user;
  const desaturate = status === GroupsStatus.OFFLINE;
  const avatarUrl = updateQuery(avatar, 'w', 80);
  return (
    <Container length={length}>
      <UserAvatar
        circular
        src={avatarUrl}
        size={size || Spacings.SPACING_10B}
        alt={name}
        desaturate={desaturate}
        className={type === 'overlay' ? 'default' : 'cursor'}
      />
      <StatusWrapper
        // @ts-ignore
        size={type === 'overlay' ? Spacings.SPACING_3B : Spacings.SPACING_10}
        position={type === 'overlay' ? Spacings.SPACING_1B : Spacings.SPACING_2}
      >
        {status === GroupsStatus.ONLINE && (
          <OnlineIndicator data-testid="groups-user-online" />
        )}
        {status === GroupsStatus.OFFLINE && (
          <OfflineIcon
            size={Spacings.SPACING_20}
            data-testid="groups-user-offline"
          />
        )}
      </StatusWrapper>
    </Container>
  );
};

export default GroupsUserAvatar;
